@if (messages.value(); as list) {
@if (list && list.length > 0) {

<div class="info-container">
  @for (msg of list; track msg) {
  <div class="info-item" [class]="msg.type.toLowerCase()">
    <span class="material-symbols-outlined">
      @switch (msg.type) {
      @case ('ERROR') { error }
      @case ('WARNING') { warning }
      @case ('INFO') { info }
      }
    </span>
    <span class="text">{{ msg.message }}</span>
  </div>
  }
</div>
}
}